import { useTranslation } from 'react-i18next';
import { cn, PaletteUtils } from '@shared/utils';
import { UserCorporateOptions, UserSecurityOptions } from './';
import { Text } from '@shared/widgets';

export const UserOptions = () => {
  const { t } = useTranslation('profile');

  return (
    <div
      className={cn(
        'h-fit w-full max-w-80 flex-none',
        'max-xl:w-full max-xl:max-w-none',
        PaletteUtils.isVcfcPalette && 'rounded-xl bg-white dark:border dark:border-gray-black dark:bg-soft-black',
      )}
    >
      <div className={cn('bg-white p-6 dark:bg-soft-black', PaletteUtils.isVcfcPalette && 'rounded-t-xl')}>
        <UserCorporateOptions />
        <UserSecurityOptions />
      </div>
      <div className={cn('bg-white p-6 dark:bg-soft-black', PaletteUtils.isVcfcPalette && 'rounded-b-xl')}>
        <div className='flex flex-col gap-4'>
          <Text center color='secondary'>
            {t('restrictions.editLimited')}
          </Text>
          <Text center color='gray'>
            {t('restrictions.contactAdmin')}
          </Text>
        </div>
      </div>
    </div>
  );
};
